module.exports = __webpack_public_path__ + "img/Picture21.17d6a039.png";